export default "__VITE_ASSET__B4BdsL5M__"